"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LoadingCard_module_css_1 = __importDefault(require("./LoadingCard.module.css"));
const GhostIcon_1 = require("../../../icons/GhostIcon");
/**
 * Loading Card
 * Shows a pulsating ghost icon as a placeholder (which fills its parent component)
 * Helpful for AB experiments that significantly affect the Page UI to prevent flickering before COF is fetched
 */
function LoadingCard({ sizeInPx = 72 }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: LoadingCard_module_css_1.default.iconWrapper, "data-testid": "LoadingCard", children: (0, jsx_runtime_1.jsx)(GhostIcon_1.GhostIconWithSquareBg, { height: sizeInPx, width: sizeInPx }) }));
}
exports.LoadingCard = LoadingCard;
//# sourceMappingURL=index.js.map